import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core'
import { ScriptResponse } from '../../../../../action-module/models/script-action'
import { Observable } from 'rxjs'
import { delay, repeatWhen } from 'rxjs/operators'
import { EntityReference } from '../../../..'
import { ActionService } from '../../../../../action-module/services/action.service'
import { Dashlet } from '../../../../models/entity-configuration'

@Component({
  selector: 'jml-lib-tile-dashlet',
  templateUrl: './tile-dashlet.component.html',
  styleUrls: ['./tile-dashlet.component.scss']
})
export class TileDashletComponent implements OnInit, OnChanges {
  @Input() dashlet: Dashlet
  @Input() entityReference: EntityReference

  actionResponse$: Observable<ScriptResponse>

  constructor(private actionService: ActionService) {}

  initActionObservable() {
    this.actionResponse$ = this.actionService.executeAction(
      { actionHrid: this.dashlet.actionHrid, entityReference: this.entityReference },
      false
    )

    if (!!this.dashlet.refreshInterval) {
      this.actionResponse$ = this.actionResponse$.pipe(
        repeatWhen((completed) => completed.pipe(delay(this.dashlet.refreshInterval * 1000)))
      )
    }
  }

  ngOnInit(): void {
    this.initActionObservable()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.entityReference && !changes.entityReference.firstChange) {
      this.initActionObservable()
    }
  }
}
